function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            //toggleActions:'play none none reverse',
        }
    })
}

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<31;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/A_Main_00${i}.avif?v=1765780684`;
    }
    
};
preloadImages()

var wFlag=window.innerWidth>750

var itemWidth = 0.3
if(!wFlag){
    itemWidth = 0.5
    const list = document.querySelector('.tornado_list');
    const items = list.querySelectorAll('.tornado_item');

    items.forEach((item, index) => {
        if (index >= 6) item.remove();
    });
}



$(()=>{
    //box2
    showUp('.box2_title')
    ScrollTrigger.create({
        trigger:'.box2_items',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_items div',{opacity:0,y:'2rem',stagger:0.2})
    })

    //box3
    var playFlag = true
    ScrollTrigger.create({
        trigger:'.box3',
        start:'top top+=20%',
        end:'+=0%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>50 && playFlag){
                $('.box3_video video')[0].play();
                playFlag = false
            }
        }
    })
    $('.box3_video video').on('ended', function () {
        $('.box3_video div').addClass('showup')
    });
    if(!wFlag){
        showUp('.box3_text')
    }
    
    //box4
    if(wFlag){
        var $video = $('.box4_video video');
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=2%',
            end:'+=80%',
            scrub:true,
            onUpdate: function (self) {
                //console.log($video[0].duration)
                $video[0].currentTime = self.progress * 2;
            }
        })
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=100% top+=2%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                //.to('.box4_video',{transform:'scale(0.5) translateY(-18%)'})
                .to('.box4_video',{scale:0.5,y:'-10%'})
                .from('.box4_title',{opacity:0,y:'2rem'})
        })
    
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=2%',
            end:'+=140%',
            pin:true
        })
    }else{
        showUp('.box4_title')
        var playFlag1 = true
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=20%',
            end:'+=0%',
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>50 && playFlag1){
                    $('.box4_video video')[0].play();
                    playFlag1 = false
                }
            }
        })
    }

    //box5
    var nexlimN1 = 10,ng_flag=true,flag_ng;
    function startNG(){
        flag_ng =  setInterval(num,30)
    }
    function num(){
        nexlimN1++;
        $(`.box5_top div p`).text(`${nexlimN1}%`)
        if(nexlimN1 > 39){
            clearInterval(flag_ng);
        }
    }

    showUp('.box5_title')
    ScrollTrigger.create({
        trigger:'.box5',
        start:'top center',
        end:'+=0%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>20){
                // 执行一次
                if(ng_flag){
                    startNG()
                    ng_flag=false;
                }
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box5',
        start:'top center-=20%',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box5_line div p',{width:0,duration:0.5,ease:'none'})
    })

    //box6
    showUp('.box6_title')
    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top+=4% top':'top top+=8%',
        end:'+=60%',
        scrub:1,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 29);
            $('.box6_mask').attr('src', `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/A_Main_00${index+1}.avif?v=1765780684`)
            if(index>28){
                $('.box6_mask').css({opacity:0})
                $('.box6_img').css({opacity:1})
            }else{
                $('.box6_mask').css({opacity:1})
                $('.box6_img').css({opacity:0})
            }
            
            $('.box6_img img:nth-child(1)').css({transform:'rotate(0deg)'})
            $('.box6_text div').css({opacity:wFlag?0.2:0})
            $('.b6Icon1').css({opacity:0})
            $('.b6Icon2').css({opacity:0})
        }
    })

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top+=70% top',
        end:'+=60%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>20){
               $('.box6_img img:nth-child(1)').css({transform:'rotate(-25deg)'})
               $('.box6_text div:nth-child(1)').css({opacity:1})
               $('.box6_text div:nth-child(2)').css({opacity:wFlag?0.2:0})
               $('.box6_bg img:nth-child(1)').css({opacity:1})
               $('.box6_bg img:nth-child(2)').css({opacity:0})
               $('.b6Icon1').css({opacity:1})
               $('.b6Icon2').css({opacity:0})
            }
            if(index>70){
                $('.box6_img img:nth-child(1)').css({transform:'rotate(25deg)'})
                $('.box6_text div:nth-child(1)').css({opacity:wFlag?0.2:0})
                $('.box6_text div:nth-child(2)').css({opacity:1})
                $('.box6_bg img:nth-child(1)').css({opacity:0})
                $('.box6_bg img:nth-child(2)').css({opacity:1})
                $('.b6Icon1').css({opacity:0})
                $('.b6Icon2').css({opacity:1})
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top+=4% top':'top top+=8%',
        end:'+=150%',
        pin:true
    })

    //box7
    showUp('.box7_title')
    ScrollTrigger.create({
        trigger:'.box7',
        start:'top+=10% top+=8%',
        end:'+=120%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box7_bg',{clipPath:wFlag?'inset(48% 0% 52% 0%)':'inset(0% 50% 0% 50%)'})
            .from('.box7_img',{x:wFlag?'-225%':'0',y:wFlag?'0':'385%'},'-=80%')
            .to('.box7_img img:last-child',{x:wFlag?'-210%':'-160%'})
            .to('.box7_img img:first-child',{x:wFlag?'-12%':'-8%',y:wFlag?'23%':'22%',scale:wFlag?'1.5':'1.3'})
    })

    ScrollTrigger.create({
        trigger:'.box7',
        start:'top top+=8%',
        end:'+=150%',
        pin:true,
    })

    //box8
    showUp('.box8_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box8',
            start:'top+=15% top+=4%',
            end:'+=15%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box8_flag',{opacity:0})
                .to('.box8_img',{y:0,scale:1},'-=80%')
        })
        ScrollTrigger.create({
            trigger:'.box8',
            start:'top top+=4%',
            end:'+=50%',
            pin:true,
        })
    }

    //box9
    showUp('.box9_title')

    //box11
    ScrollTrigger.create({
        trigger:'.box11',
        start:'top top+=8%',
        end:'+=0%',
        animation:gsap.timeline()
            .from('.box11_item div:nth-child(1) p:last-child img:nth-child(2)',{y:'-1.5rem'})
            .from('.box11_item div:nth-child(1) p:last-child img:nth-child(3)',{y:'1.5rem'},'<')
            .from('.box11_item div:nth-child(2) p:last-child img:nth-child(2)',{x:'1.5rem'},'<')
            .from('.box11_item div:nth-child(3) p:last-child img:nth-child(n+2)',{y:'-1.5rem'},'<')
    })

    //flavorsSwiper
    new Swiper('.flavorsSwiper', {
        slidesPerView:wFlag?3:1.5,
        centeredSlides: true,
        autoplay:true,
        navigation: {
            nextEl: '.flavorsSwiper-button-next',
            prevEl: '.flavorsSwiper-button-prev',
        }
    })

    //flavors specs package
    showUp('.flavors_title')
    showUp('.specs_img')
    showUp('.package_title')

})

     
// DOM 准备好后初始化
document.addEventListener("DOMContentLoaded", () => {
    initTornado();
});

function initTornado(wrapperSelector = ".tornado_wrapper") {
    const wrapper = document.querySelector(wrapperSelector);
    if (!wrapper) return;
    const list  = wrapper.querySelector(".tornado_list");
    const cards = wrapper.querySelectorAll(".tornado_item");
    const pics  = wrapper.querySelectorAll(".teammate_pic");
    
    if (!cards.length) return;
    
    // 给头像略微上下错位（-25 / 0 / 25 循环）
    gsap.set(pics, {
        yPercent: i => gsap.utils.wrap([-25, 0, 25], i)
    });
    // gsap.set(cards, {
    //     rotateZ: i => gsap.utils.wrap([-8, -4, 0, 4, 8], i)
    // });
    
    // 设置每个 item 的 transform-origin（圆柱半径）
    function setTransformOrigin() {
        // 调整宽度
        const radius = -window.innerWidth * itemWidth; // 和原站类似
        gsap.set(cards, {
            transformOrigin: `50% 50% ${radius}px`
        });
    }
    setTransformOrigin();
    
    // 无限旋转时间轴（只有旋转，没有进场）
    const spinTl = gsap.timeline({
        paused: true,         // 默认暂停，滚动到视口再播放
        repeat: -1,
        defaults: {
            ease: "none",
            duration: 30        // 一圈时长，可自行调
        }
    });
    
    // 均匀分布到 360° 上，然后整体 -=360 做无限旋转
    spinTl.fromTo(
    cards,
    {
        rotationY: i => (i * 360) / cards.length
    },
    {
        rotationY: "-=360"
    }
    );
    
    //spinTl.play();
    // ScrollTrigger 控制何时转、何时停
    ScrollTrigger.create({
        trigger: wrapper,
        start: "top bottom",
        end: "+=99999", // 永远有效
        onEnter: () => spinTl.play(),
        // scrub: true,
        // invalidateOnRefresh: true,
        
        onToggle: self => {
            if (self.isActive) {
                spinTl.play();
            } else {
                spinTl.pause();
            }
        },
        
        onRefresh: () => {
            // resize 后重算 3D 场景
            setTransformOrigin();
            gsap.set(pics, {
                yPercent: i => gsap.utils.wrap([-25, 0, 25], i)
            });
        }
    });
    
    ScrollTrigger.refresh();
}
